/* eslint @typescript-eslint/no-explicit-any: "off", "no-console": "off" */

import { ApiError } from '@api/utils/ApiError';

export class Log {

	static logs: string[] = [];

	static readonly MAX_ITEMS: number = 300;

	static message(...args: any[]) {
		const log = [`${(new Date()).toString()}:`].concat(args.slice());

		if (console && console.log) {
			console.log(...log);
		}

		if (!IS_SSR) {
			this.logs.push(log.join(' '));
			this.slice();
		}
	}

	static error(...args: any[]) {
		const log = [`${(new Date()).toString()}:`].concat(args.slice());

		if (console && console.error) {
			console.error(...log);
		}

		if (!IS_SSR) {
			this.logs.push(log.join(' '));
			this.slice();
		}
	}

	static errorRequest(err: ApiError) {
		if (err && err.request) {
			const {
				status,
				request: {
					url = '',
					method = '',
					data,
				},
			} = err;

			Log.error(`Failed network request: ${status} ${method.toUpperCase()} ${url} ${data}`);
			if (err.body) {
				Log.error(`Body: ${err.body}`);
			}
			if (err.message) {
				Log.error(`Error message: ${err.message}`);
			}
		}
	}

	static slice() {
		this.logs = this.logs.slice(-this.MAX_ITEMS);
	}

	static getLogs() {
		return this.logs;
	}

}
